import { Pipe, PipeTransform } from '@angular/core';
import { WrapInParenthesis } from '@app/core/utilities/string.utilities';

@Pipe({ name: 'wrapInParenthesis' })
export class WrapInParenthesisPipe implements PipeTransform {
  transform(value: string): string {
    return WrapInParenthesis(value);
  }
}
